import React from 'react';
import CustomFieldsManager from '../../CustomFieldsManager';

interface Props {
  authToken: string;
}

const CustomFieldsSection: React.FC<Props> = ({ authToken }) => (
  <CustomFieldsManager authToken={authToken} />
);

export default CustomFieldsSection;
